<template>
  <b-form class="longtermuserform">
    <slot name="banner"></slot>
    <b-form class="longtermuserform__form">
      <section class="longtermuserform__form-authority">
        <b-form-checkbox
          :checked="longTermUser.authority"
          :disabled="disabled"
          @input="userDataHandler($event, 'authority')"
          switch
        >
          權限開通
        </b-form-checkbox>

        <b-form-checkbox
          :checked="!longTermUser.verification"
          :disabled="disabled"
          @change="userDataHandler(!$event, 'verification')"
          switch
        >
          免身份驗證
        </b-form-checkbox>
      </section>
      <FormTitle titleText="乘客資料" />

      <BaseInput
        labelText="*姓名"
        :value="longTermUser.name"
        :disabled="disabled"
        name="name"
        validation="required"
        @input="userDataHandler($event, 'name')"
        class="longtermuserform__form-field"
      />

      <BaseInput
        labelText="*聯絡人"
        :value="longTermUser.contactPerson"
        :disabled="disabled"
        name="contactPerson"
        validation="required"
        @input="userDataHandler($event, 'contactPerson')"
        class="longtermuserform__form-field"
      />

      <BaseSelect
        labelText="*區域類型"
        :value="longTermUser.areaType"
        :text="areaTypeMap(longTermUser.areaType)"
        :options="areaTypeOptions"
        :disabled="disabled"
        :required="true"
        @select="userDataHandler($event, 'areaType')"
        class="longtermuserform__form-field"
      />

      <section class="longtermuserform__form-field">
        <BaseSelect
          labelText="*身份別"
          :value="longTermUser.class"
          :text="classMap(longTermUser.class)"
          :options="classOptions"
          :disabled="disabled"
          :required="true"
          @select="userDataHandler($event, 'class')"
        />
        <div class="longtermuserform__form-field-community">
          <b-form-checkbox
            :disabled="disabled"
            :checked="longTermUser.communityLimitedFrequency > 0"
            @input="communityChecked = $event"
            switch
          >
            社區式接送
          </b-form-checkbox>
          <b-form-input
            v-if="communityChecked"
            type="number"
            placeholder="請輸入上限次數"
            :value="longTermUser.communityLimitedFrequency"
            :min="0"
            @input="
              userDataHandler(Number($event), 'communityShuttleFrequency')
            "
            class="longtermuserform__form-field-community-input"
          ></b-form-input>
        </div>
      </section>

      <BaseInput
        labelText="*手機一"
        type="tel"
        :value="longTermUser.firstMobilePhoneNumber"
        :disabled="disabled"
        name="firstMobilePhoneNumber"
        validation="required|mobile"
        @input="userDataHandler($event, 'firstMobilePhoneNumber')"
        class="longtermuserform__form-field"
      />

      <BaseInput
        labelText="住家電話"
        type="tel"
        :value="longTermUser.telephoneNumber"
        :disabled="disabled"
        name="telephoneNumber"
        validation="phone"
        @input="userDataHandler($event, 'telephoneNumber')"
        class="longtermuserform__form-field"
      />

      <BaseInput
        labelText="手機二"
        type="tel"
        :value="longTermUser.secondMobilePhoneNumber"
        :disabled="disabled"
        name="secondMobilePhoneNumber"
        validation="mobile"
        @input="userDataHandler($event, 'secondMobilePhoneNumber')"
        class="longtermuserform__form-field"
      />

      <BaseSelect
        labelText="*行政區"
        :value="longTermUser.area"
        :text="districtMap(longTermUser.area)"
        :headerText="districtOptions.city"
        :options="districtOptions.areas"
        :disabled="disabled"
        :required="true"
        @select="userDataHandler($event, 'area')"
        class="longtermuserform__form-field"
      />

      <BaseInput
        labelText="*身分證"
        :value="longTermUser.identityCode"
        :disabled="disabled"
        name="identityCode"
        validation="required|identify"
        @input="userDataHandler($event, 'identityCode')"
        class="longtermuserform__form-field"
      />

      <div class="longtermuserform__form-field">
        <!-- <BaseInput
          labelText="住家地址"
          :value="longTermUser.address"
          :disabled="disabled"
          @input="userDataHandler($event, 'address')"
        /> -->
        <AutoComplete
          id="userAddress"
          :value="longTermUser.address"
          :disabled="disabled"
          :items="locationList"
          name="onLocation"
          labelText="住家地址"
          @input="handleLocationKeyword"
          @selectDropdownItem="selectLocation"
        />
        <p class="longtermuserform__form-field-gps">
          GPS: {{ longTermUser.gps }}
        </p>
      </div>

      <BaseCheckGroup
        labelText="偏好服務"
        :checked="longTermUser.service"
        :options="serviceOptions"
        :disabled="disabled"
        @change="userDataHandler($event, 'service')"
        class="longtermuserform__form-field"
      />

      <BaseTextarea
        labelText="備註"
        :value="longTermUser.note"
        :disabled="disabled"
        @input="userDataHandler($event, 'note')"
        class="longtermuserform__form-field"
      />

      <section v-if="$route.name === 'longTermUser' && disabled">
        <FormImmutableField
          title="自付比例"
          :text="`${longTermUser.selfPayRatio}%`"
          class="longtermuserform__form-field hugelabel"
        />
        <FormImmutableField
          title="當月就醫接送上限"
          :text="`NT ${longTermUser.subsidyMaximumAmount}`"
          class="longtermuserform__form-field hugelabel"
        />
        <FormImmutableField
          title="當月就醫接送剩餘"
          :text="`NT ${longTermUser.subsidyLastAmount}`"
          class="longtermuserform__form-field hugelabel"
        />
        <FormImmutableField
          title="當月社區式接送上限"
          :text="longTermUser.communityShuttleFrequency"
          class="longtermuserform__form-field hugelabel"
        />
        <FormImmutableField
          title="當月社區式接送剩餘"
          :text="longTermUser.lastCommunityShuttleFrequency"
          class="longtermuserform__form-field hugelabel"
        />
      </section>

      <footer class="longtermuserform__form-footer" v-if="!disabled">
        <div class="longtermuserform__form-avator">
          <label>頭像</label>
          <div class="longtermuserform__form-avator-wrapper">
            <div class="longtermuserform__form-avator-control">
              <!-- :class="{ invisible: avatorPreviewURL }" -->
              <!-- v-if="!avatorPreviewURL" -->
              <div class="longtermuserform__form-avator-dragger">
                + 拖曳 / 點擊上傳圖片
              </div>
              <b-form-file accept=".png,.jpg,.jpeg,.svg" @input="handleAvator">
              </b-form-file>
            </div>

            <div
              class="longtermuserform__form-avator-preview"
              v-if="avatorPreviewURL"
            >
              <div
                class="longtermuserform__form-avator-reset"
                @click="resetAvator"
              >
                x
              </div>
              <div class="longtermuserform__form-avator-image">
                <img :src="avatorPreviewURL" alt="User avator" />
              </div>
            </div>

            <p>IMAGE/JPEG - 圖片檔案 - 需小於 300 kb</p>
          </div>
        </div>
      </footer>
      <div class="longtermuserform__button-group" v-if="!disabled">
        <BaseButtonGroup
          positiveText="確認"
          negativeText="取消"
          @positive="onSubmit"
          @negative="$emit('onReset')"
        />
        <b-button
          v-if="$listeners['deleteOne']"
          class="longtermuserform__button-delete"
          variant="danger"
          @click.prevent="$emit('deleteOne')"
          >刪除用戶</b-button
        >
      </div>
    </b-form>
  </b-form>
</template>

<script>
import BaseInput from '@/components/base/BaseInput';
import BaseTextarea from '@/components/base/BaseTextarea';
import BaseSelect from '@/components/base/BaseSelect';
import BaseCheckGroup from '@/components/base/BaseCheckGroup';
import BaseButtonGroup from '@/components/base/BaseButtonGroup';
import FormTitle from '@/components/commen/FormTitle';
import FormImmutableField from '@/components/commen/FormImmutableField';
import AutoComplete from '@/components/commen/AutoComplete';

import { classMap, areaTypeMap, districtMap } from '@/utils/optionMaps';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LongTermUserForm',
  components: {
    BaseInput,
    BaseTextarea,
    BaseSelect,
    BaseCheckGroup,
    BaseButtonGroup,
    FormTitle,
    FormImmutableField,
    AutoComplete
  },
  props: {
    areaTypeOptions: {
      type: Array,
      required: true
    },
    classOptions: {
      type: Array,
      required: true
    },
    districtOptions: {
      type: Object,
      required: true
    },
    serviceOptions: {
      type: Array,
      required: true
    },
    longTermUser: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      communityChecked: false,
      avatorPreviewURL: null
    };
  },
  methods: {
    ...mapActions({
      fetchLocationList: 'longTerm/fetchLocationList'
    }),
    userDataHandler(value, property) {
      this.$emit('userDataHandler', {
        value,
        property
      });
    },
    userDataProcess(data) {
      return Object.keys(data).reduce((accu, curr) => {
        if (curr === 'communityShuttleFrequency' && !data[curr]) return accu;
        if (curr === 'telephoneNumber' && !data[curr]) return accu;
        if (curr === 'secondMobilePhoneNumber' && !data[curr]) return accu;
        if (curr === 'gps' && !data[curr]) return accu;
        if (curr === 'note' && !data[curr]) return accu;
        if (curr === 'photo' && !data[curr]) return accu;
        if (curr === 'service' && !data[curr].length) return accu;
        accu[curr] = data[curr];
        return accu;
      }, {});
    },
    onSubmit() {
      const user = {
        ...this.longTermUser,
        communityShuttleFrequency: Number(
          this.longTermUser.communityShuttleFrequency
        ),
        service: this.longTermUser.service.join()
        // gps: this.parseGps2String(this.longTermUser)
      };
      const userData = this.userDataProcess(user);

      this.$emit('onSubmit', userData);
    },
    parseGps2String(userData) {
      if (userData.gps) return this.longTermUser.gps.join();
      if (userData.addressGps) return this.longTermUser.addressGps.join();
    },
    handleAvator(file) {
      // console.log(file.size / 1000);
      if (file.size / 1000 > 299) {
        this.$store.commit('errorMessage', '頭像檔案大小需小於 300 kb');
        this.$root.$emit('bv::show::modal', 'error-modal');
        return;
      }
      this.avatorPreviewURL = URL.createObjectURL(file);
      this.userDataHandler(file, 'photo');
    },
    resetAvator() {
      this.avatorPreviewURL = null;
    },
    classMap(value) {
      return classMap(value);
    },
    areaTypeMap(value) {
      return areaTypeMap(value);
    },
    districtMap(value) {
      return districtMap(value);
    },
    async handleLocationKeyword(keyword) {
      this.userDataHandler(keyword, 'address');
      if (keyword.length > 5) {
        await this.fetchLocationList(keyword);
      }
    },
    selectLocation(location) {
      const gps = location.latitude + ',' + location.longitude;
      this.userDataHandler(location.address, 'address');
      this.userDataHandler(gps, 'gps');
      // if (location.id) {
      //   this.selectGoogleLocation(
      //     location.id,
      //     location.address,
      //     'inputOnLocation'
      //   );
      // } else if (location.name) {
      //   this.$emit('inputOnLocation', {
      //     ...location,
      //     address: location.address.replace(location.name, '').replace('-', '')
      //   });
      // } else {
      //   this.$emit('inputOnLocation', location);
      // }
    }
  },
  computed: {
    ...mapGetters({
      locationList: 'longTerm/locationList'
    })
  },
  mounted() {
    console.log(this.$route.name);
    this.communityChecked = this.longTermUser.communityLimitedFrequency > 0;
  }
};
</script>

<style lang="scss" scoped>
.longtermuserform {
  &__form {
    padding: 20px 20px;
    border: 2px solid #ebeef5;

    &-title {
      position: relative;
      text-align: center;
      span {
        background: #fff;
        padding: 0 5px;
        &:after {
          display: block;
          content: '';
          top: 50%;
          margin-top: -2px;
          width: 100%;
          position: absolute;
          border: 1px solid #e5e5e5;
          z-index: -1;
        }
      }
    }

    &-field {
      padding: 20px 80px;
      border-bottom: 1px solid #ededed;
      &:hover {
        background-color: #fafafa;
      }
      label {
        flex: 0 0 80px;
        margin-bottom: 0;
      }
      &-community {
        display: flex;
        align-items: center;
        height: 40px;
        padding-left: 90px;
        margin-top: 10px;
        .custom-switch {
          z-index: 0;
        }
        .custom-switch {
          display: inline-block;
          margin-right: 20px;
        }
        &-input {
          display: inline-block;
          width: auto;
        }
      }
      &-gps {
        margin-top: 5px;
        padding-left: 80px;
      }
    }

    footer {
      padding: 20px 80px;
      margin-bottom: 30px;
    }

    &-authority {
      display: flex;
      justify-content: space-between;
      padding: 0 80px;
      margin-bottom: 20px;
      .custom-control:first-child {
        margin-right: 20px;
      }
    }

    &-avator {
      &-control {
        height: 180px;
      }
      &-wrapper {
        position: relative;
      }
      &-dragger {
        background-color: #fff;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        box-sizing: border-box;
        width: 360px;
        height: 180px;
        line-height: 180px;
        text-align: center;
        position: absolute;
        overflow: hidden;
      }
      p {
        font-size: 12px;
      }
      &-preview {
        position: absolute;
        top: 0;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        width: 360px;
        height: 180px;
        box-sizing: border-box;
      }
      &-image {
        width: 360px;
        height: 180px;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      &-reset {
        position: absolute;
        z-index: 2;
        width: 40px;
        height: 40px;
        background-color: #909399;
        border-radius: 99999px;
        top: -20px;
        left: 160px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        color: #fff;
      }
    }
  }

  &__button {
    &-group {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
    &-delete {
      padding: 8px 20px;
      margin-left: 30px;
      font-size: 14px;
      line-height: 1;
    }
  }
}

::v-deep .custom-file-label {
  width: 360px;
  height: 180px;
  opacity: 0;
}

.invisible {
  opacity: 0;
}
</style>
